var _circle, _path, _g, _path2, _path3, _rect, _path4, _path5, _circle2, _rect2, _rect3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 172,
    viewBox: "0 0 130 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64.5,
    cy: 57.5,
    r: 57.5,
    fill: "#DAE8FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.8457 10.376H75.7404L61.9059 39.3421H74.0111L87.8457 10.376Z",
    fill: "#00336F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.34,
    filter: "url(#filter0_f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.3984 64.094C36.3984 61.8848 38.1893 60.094 40.3984 60.094H89.0338C91.2429 60.094 93.0338 61.8849 93.0338 64.094V131.752C93.0338 133.961 91.2429 135.752 89.0338 135.752H40.3984C38.1893 135.752 36.3984 133.961 36.3984 131.752V64.094Z",
    fill: "#1D589D",
    fillOpacity: 0.81
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3193 35.5602C27.3193 33.351 29.1102 31.5602 31.3193 31.5602H97.6802C99.8894 31.5602 101.68 33.351 101.68 35.5602V122.673C101.68 124.882 99.8894 126.673 97.6802 126.673H31.3193C29.1102 126.673 27.3193 124.882 27.3193 122.673V35.5602Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M101.68 46.6918H27.3193",
    stroke: "#DAE8FA",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 48.5034,
    y: 37.6128,
    width: 32.4248,
    height: 1.72932,
    fill: "#DAE8FA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.837 37.6128H62.7317L61.9058 39.3421H74.011L74.837 37.6128Z",
    fill: "#00336F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1538 10.376H53.2591L67.0937 39.3421H54.9884L41.1538 10.376Z",
    fill: "#0067DF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 64.4998,
    cy: 72.6316,
    r: 17.2932,
    fill: "#DAE8FA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 43.748,
    y: 96.8422,
    width: 42.3684,
    height: 3.45865,
    rx: 1.72932,
    fill: "#BADAFF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 50.2329,
    y: 103.759,
    width: 29.3985,
    height: 3.45865,
    rx: 1.72932,
    fill: "#DAE8FA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f",
    x: 0.398438,
    y: 24.094,
    width: 128.635,
    height: 147.658,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18,
    result: "effect1_foregroundBlur"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignup);
export default __webpack_public_path__ + "static/media/signup.534f3b35d5318ad7ef8953d3c984d555.svg";
export { ForwardRef as ReactComponent };